/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Unassigned_RowInputs */



/**
* | output |
* | --- |
* | "Unassigned" |
*
* @param {Speakers_Metrics_Unassigned_RowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_unassigned_row = /** @type {((inputs?: Speakers_Metrics_Unassigned_RowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Unassigned_RowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "es") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Unassigned")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unassigned")
	return /** @type {LocalizedString} */ ("Unassigned")
});